import { component } from 'picoapp';
import Drawer from '../../js/utils/drawer';
import Ready from '../../js/utils/ready';

export default component(async (node) => {
  const triggers = document.querySelectorAll(`[data-trigger=${node.id}]`);
  const campaignBanner = document.querySelector('[data-campaign]');

  Ready(() => {
    document.documentElement.style.setProperty('--campaign', `${campaignBanner.scrollHeight}px`);
  });

  const drawer = Drawer(node);

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      if (!trigger.hasAttribute('data-clicked')) {
        drawer.open();
      }

      trigger.setAttribute('data-clicked', 'true');
    });
  });

  const toggleChildren = () => {
    triggers.forEach((trigger) => {
      trigger.childNodes.forEach((child) => {
        child.hidden = !child.hidden;
      });
    });
  };

  drawer.on('open', () => {
    campaignBanner.style.zIndex = '9999';
    toggleChildren();

    // Hacky scroll fix, because of repaint
    setTimeout(() => {
      node.firstElementChild.scrollTop = 0;
    }, 50);
  });

  drawer.on('close', () => {
    toggleChildren();
  });

  drawer.on('closed', () => {
    campaignBanner.style.zIndex = 'auto';

    triggers.forEach((trigger) => {
      trigger.removeAttribute('data-clicked');
    });
  });
});
